<template>
    <b-dropdown @show="handleOpened" @click="handleClicked" split :class="{'BreadcrumbDropdown--unique':isUnique}" ref="dropdown">
        <template v-slot:button-content>
            {{ text }}
        </template>
        <template v-if="!items">
            <div v-loading="true" style="height: 5rem"></div>
        </template>
        <template v-else-if="isUnique">
            <b-dropdown-item disabled> <slot name="unique-message">Aucun autre item trouvé</slot></b-dropdown-item>
        </template>
        <template v-else>
            <template v-for="item in filteredItems">
                <b-dropdown-item :href="item[urlProp]" :key="item.id">
                    <div class="dropdown-item-inner">
                        {{ item[nameProp] }} <slot name="append" :item="item" />
                    </div>
                </b-dropdown-item>
            </template>
        </template>
    </b-dropdown>
</template>

<script>
    import Vue from 'vue';
    import ElLoading from 'element-loading';
    import { BDropdown, BDropdownItem } from 'bootstrap-vue';
    import axios from 'axios';

    Vue.use(ElLoading);

    export default {
        components: {
            BDropdown,
            BDropdownItem,
        },
        props: {
            endpoint: String,
            url: String,
            text: String,
            currentId: Number,
            urlProp: {
                type: String,
                default: 'url'
            },
            nameProp: {
                type: String,
                default: 'name'
            }
        },
        data() {
            return {
                items: null
            }
        },
        computed: {
            isUnique() {
                return this.items?.length === 1;
            },
            filteredItems() {
                return this.items?.filter(item => item.id !== this.currentId);
            },
        },
        methods: {
            handleOpened() {
                if(!this.items) {
                    axios.get(this.endpoint).then(response => {
                        this.items = response.data;
                    });
                }
            },
            handleClicked() {
                if(this.url) {
                    location.href = this.url;
                }
            }
        }
    }
</script>
